import { Button } from "@/components/ui/button";
import { CreditCard, Wallet, Users, Plus, DoorOpen } from "lucide-react";

export default function PaymentActionsBar({
  total,
  account,
  onPay,
  onMultiPay,
  onSplit,
  onAddMore,
  onCloseTable,
}) {
  return (
    <div className="bg-white border-t">
      <div className="px-4 py-4 border-b">
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-500">Total a pagar</span>
          <span className="text-3xl font-black text-emerald-600">€{total.toFixed(2)}</span>
        </div>
        {account?.guests && (
          <div className="mt-3 pt-3 border-t border-gray-100 space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-600">Personas</span>
              <span className="font-medium">{account.guests}</span>
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-600">Importe por persona</span>
              <span className="font-medium">€{(account.per_person || 0).toFixed(2)}</span>
            </div>
          </div>
        )}
      </div>

      <div className="p-3 grid grid-cols-2 gap-2">
        <Button
          className="h-14 bg-emerald-600 hover:bg-emerald-700 font-bold flex-col gap-0.5"
          onClick={onPay}
          disabled={total === 0}
          data-testid="pos-pay-btn"
        >
          <CreditCard className="w-5 h-5" />
          <span className="text-[10px]">RECEBER</span>
        </Button>
        <Button
          className="h-14 bg-purple-600 hover:bg-purple-700 font-bold flex-col gap-0.5"
          onClick={onMultiPay}
          disabled={total === 0}
          data-testid="pos-multi-pay-btn"
        >
          <Wallet className="w-5 h-5" />
          <span className="text-[10px]">MULTI-PAGO</span>
        </Button>
        <Button
          className="h-14 bg-blue-600 hover:bg-blue-700 font-bold flex-col gap-0.5"
          onClick={onSplit}
          disabled={total === 0}
          data-testid="pos-split-btn"
        >
          <Users className="w-5 h-5" />
          <span className="text-[10px]">DIVIDIR</span>
        </Button>
        <Button
          className="h-14 bg-amber-500 hover:bg-amber-600 font-bold flex-col gap-0.5"
          onClick={onAddMore}
          data-testid="pos-add-more-btn"
        >
          <Plus className="w-5 h-5" />
          <span className="text-[10px]">MAIS ITENS</span>
        </Button>
      </div>

      {total === 0 && (
        <div className="px-3 pb-3">
          <Button
            variant="outline"
            className="w-full h-12 font-bold border-gray-300 text-emerald-700 border-emerald-300"
            onClick={onCloseTable}
            data-testid="pos-close-table-btn"
          >
            <DoorOpen className="w-4 h-4 mr-2" />
            ENCERRAR MESA
          </Button>
        </div>
      )}
    </div>
  );
}
